import { reactive, ref } from 'vue';
import { ajax200Res } from '@/js/utils';
import __unimport_mukiConst from '@/js/const.js';import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '@/assets/images/logo/civil-logo.svg';
import _imports_1 from '@/assets/images/icon/point.svg';
import _imports_2 from '@/assets/images/icon/sale.svg';
import _imports_3 from '@/assets/images/icon/alarm-clock.svg';
import _imports_4 from '@/assets/images/icon/love.svg';
import _imports_5 from '@/assets/images/icon/tomato.svg';

var _hoisted_1 = /*#__PURE__*/_createVNode("i", {
  class: "icon-menu_hamgurg"
}, null, -1);

var _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1);

var _hoisted_3 = {
  class: "page-content",
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
var _hoisted_4 = {
  class: "colored-bed member-info-bed",
  style: {
    "padding": "10px 0"
  }
};
var _hoisted_5 = {
  class: "bed-inner"
};

var _hoisted_6 = /*#__PURE__*/_createVNode("div", {
  class: "btn-prepend"
}, [/*#__PURE__*/_createVNode("i", {
  class: "icon-bar-code"
})], -1);

var _hoisted_7 = /*#__PURE__*/_createVNode("div", {
  class: "btn-main text-bold"
}, " 會員條碼 / 載具 ", -1);

var _hoisted_8 = {
  class: "info-icon-item points-displayer"
};

var _hoisted_9 = /*#__PURE__*/_createVNode("div", {
  class: "item-prepend"
}, [/*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "",
  srcset: ""
})], -1);

var _hoisted_10 = {
  key: 0,
  class: "item-content"
};
var _hoisted_11 = {
  key: 1,
  class: "item-content"
};
var _hoisted_12 = {
  class: "page-inner",
  style: {
    "position": "relative",
    "z-index": "1",
    "padding-top": "15px"
  }
};
var _hoisted_13 = {
  id: "feature-menu-block",
  class: "simple-bed",
  style: {
    "flex-grow": "1"
  }
};

var _hoisted_14 = /*#__PURE__*/_createVNode("div", {
  class: "btn-icon"
}, [/*#__PURE__*/_createVNode("i", {
  class: "icon-addition"
})], -1);

var _hoisted_15 = /*#__PURE__*/_createVNode("p", {
  class: "feature-text"
}, " 線上預購 ", -1);

var _hoisted_16 = /*#__PURE__*/_createVNode("div", {
  class: "btn-icon"
}, [/*#__PURE__*/_createVNode("i", {
  class: "icon-shopping-bag"
})], -1);

var _hoisted_17 = /*#__PURE__*/_createVNode("p", {
  class: "feature-text"
}, " 生活提案 ", -1);

var _hoisted_18 = /*#__PURE__*/_createVNode("div", {
  class: "btn-icon"
}, [/*#__PURE__*/_createVNode("i", {
  class: "icon-checklist"
})], -1);

var _hoisted_19 = /*#__PURE__*/_createVNode("p", {
  class: "feature-text"
}, " 訂單查詢 ", -1);

var _hoisted_20 = /*#__PURE__*/_createVNode("div", {
  class: "btn-icon"
}, [/*#__PURE__*/_createVNode("i", {
  class: "icon-video-game"
})], -1);

var _hoisted_21 = /*#__PURE__*/_createVNode("p", {
  class: "feature-text"
}, " 遊樂場 ", -1);

var _hoisted_22 = /*#__PURE__*/_createVNode("div", {
  class: "btn-icon"
}, [/*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "",
  srcset: ""
})], -1);

var _hoisted_23 = /*#__PURE__*/_createVNode("p", {
  class: "feature-text"
}, " 優惠資訊 ", -1);

var _hoisted_24 = /*#__PURE__*/_createVNode("div", {
  class: "btn-icon"
}, [/*#__PURE__*/_createVNode("i", {
  class: "icon-delivery"
})], -1);

var _hoisted_25 = /*#__PURE__*/_createVNode("p", {
  class: "feature-text"
}, " 行動超市 ", -1);

var _hoisted_26 = /*#__PURE__*/_createVNode("div", {
  class: "btn-icon"
}, [/*#__PURE__*/_createVNode("i", {
  class: "icon-megaphone"
})], -1);

var _hoisted_27 = /*#__PURE__*/_createVNode("p", {
  class: "feature-text"
}, " 活動訊息 ", -1);

var _hoisted_28 = /*#__PURE__*/_createVNode("div", {
  class: "btn-icon"
}, [/*#__PURE__*/_createVNode("i", {
  class: "icon-contract"
})], -1);

var _hoisted_29 = /*#__PURE__*/_createVNode("p", {
  class: "feature-text"
}, " 消費紀錄 ", -1);

var _hoisted_30 = {
  class: "section-head"
};

var _hoisted_31 = /*#__PURE__*/_createVNode("div", {
  class: "head-col"
}, [/*#__PURE__*/_createVNode("div", {
  class: "section-title"
}, [/*#__PURE__*/_createVNode("img", {
  class: "title-icon",
  src: _imports_3,
  alt: "",
  srcset: ""
}), /*#__PURE__*/_createTextVNode(" 焦點預購 ")])], -1);

var _hoisted_32 = {
  class: "head-col"
};
var _hoisted_33 = {
  class: "product-box-block"
};
var _hoisted_34 = {
  key: 1
};
var _hoisted_35 = {
  class: "section-head"
};
var _hoisted_36 = {
  class: "head-col"
};
var _hoisted_37 = {
  class: "section-title"
};

var _hoisted_38 = /*#__PURE__*/_createVNode("img", {
  class: "title-icon",
  src: _imports_4,
  alt: "",
  srcset: ""
}, null, -1);

var _hoisted_39 = {
  class: "media-block"
};
var _hoisted_40 = {
  class: "section-head"
};
var _hoisted_41 = {
  class: "head-col"
};
var _hoisted_42 = {
  class: "section-title"
};

var _hoisted_43 = /*#__PURE__*/_createVNode("img", {
  class: "title-icon",
  src: _imports_4,
  alt: "",
  srcset: ""
}, null, -1);

var _hoisted_44 = {
  class: "media-block"
};
var _hoisted_45 = {
  class: "section-head"
};
var _hoisted_46 = {
  class: "head-col"
};
var _hoisted_47 = {
  class: "section-title"
};

var _hoisted_48 = /*#__PURE__*/_createVNode("img", {
  class: "title-icon",
  src: _imports_4,
  alt: "",
  srcset: ""
}, null, -1);

var _hoisted_49 = {
  class: "media-block media-block_3count"
};

var _hoisted_50 = /*#__PURE__*/_createVNode("div", {
  class: "section-head"
}, [/*#__PURE__*/_createVNode("div", {
  class: "head-col"
}, [/*#__PURE__*/_createVNode("div", {
  class: "section-title"
}, [/*#__PURE__*/_createVNode("img", {
  class: "title-icon",
  src: _imports_5,
  alt: "",
  srcset: ""
}), /*#__PURE__*/_createTextVNode(" 活動訊息 ")])])], -1);

var _hoisted_51 = {
  class: "media-block"
};
import { goMobileStore } from '@/js/functions.js';
import { baseGet, basePost, Index, Other, YoungSun } from "@/js/services/baseService";
import { useStore } from 'vuex';
import axios from 'axios';
import { watch } from 'vue';
export default {
  expose: [],
  setup: function setup(__props) {
    var _reactive;

    // import { useI18n } from "vue-i18n";
    var pageData = reactive((_reactive = {
      member_code: '',
      carrier: '',
      showcase_media: '',
      ad_block: [],
      event_block: {},
      product_list: [],
      appBanner: [],
      websiteBanner: [],
      banner: []
    }, _defineProperty(_reactive, "product_list", [// "id": 2,
      // "spec_id": 2,
      // "is_collect": 0,
      // "countdown": 54,
      // "name": "百事可樂/七喜汽水 2L",
      // "pic_src": "https://cf.shopee.tw/file/77f321f80df5685c3e60560afb6037fe",
      // "stock": 3,
      // "ori_price": 1280,
      // "price": 1080,
      // "points": 30
    ]), _defineProperty(_reactive, "test", {
      age: 55
    }), _reactive)); // store

    var store = useStore(); // auth

    var authInfo = store.getters['auth/authInfo'];
    var btnActiveName = ref(null);
    var childComponentRef = ref(null);

    var openCodePopup = function openCodePopup() {
      if (childComponentRef.value) {
        childComponentRef.value.getMemberCardNumber();
      }

      f7.popup.open('.popup-codes');
    }; // 首頁 - 輪播


    var ps2 = Other.get_banner().then(function (res) {
      var _ajax200Res = ajax200Res(res),
          onSuccess = _ajax200Res.onSuccess,
          onFail = _ajax200Res.onFail;

      onSuccess(function (_ref) {
        var res = _ref.res,
            data = _ref.data,
            msg = _ref.msg,
            defaultAlert = _ref.defaultAlert;

        if (data) {
          pageData.appBanner = data.map(function (item) {
            return {
              pic_src: item.pic_src,
              url: item.url_link
            };
          });
        }
      });
      onFail(function (_ref2) {
        var res = _ref2.res,
            data = _ref2.data,
            msg = _ref2.msg,
            defaultAlert = _ref2.defaultAlert;
        defaultAlert();
      });
    });
    var ps1 = Index.index().then(function (res) {
      var _ajax200Res2 = ajax200Res(res),
          onSuccess = _ajax200Res2.onSuccess,
          onFail = _ajax200Res2.onFail;

      onSuccess(function (_ref3) {
        var res = _ref3.res,
            data = _ref3.data,
            msg = _ref3.msg,
            defaultAlert = _ref3.defaultAlert;

        if (data) {
          for (var key in pageData) {
            if (data[key] !== undefined) {
              if (key == 'banner') {
                pageData['websiteBanner'] = data[key];
              } else {
                pageData[key] = data[key];
              }
            }
          }

          ;
        }
      });
      onFail(function (_ref4) {
        var res = _ref4.res,
            data = _ref4.data,
            msg = _ref4.msg,
            defaultAlert = _ref4.defaultAlert;
        defaultAlert();
      });
    });
    Promise.allSettled([ps1, ps2]).then(function () {
      pageData.banner = pageData.banner.concat(pageData.appBanner).concat(pageData.websiteBanner);
    });
    var hasFetchedPoints = ref(false);

    var getPoint = function getPoint(type) {
      if (type === 'queryPoints') {
        hasFetchedPoints.value = true;
      }

      store.dispatch('auth/updateMemberData').then(function () {
        store.dispatch('auth/updateMemberPointRecord');
      });
    };

    return function (_ctx, _cache) {
      var _component_f7_link = _resolveComponent("f7-link");

      var _component_f7_nav_left = _resolveComponent("f7-nav-left");

      var _component_f7_nav_title = _resolveComponent("f7-nav-title");

      var _component_MailIndicator = _resolveComponent("MailIndicator");

      var _component_f7_nav_right = _resolveComponent("f7-nav-right");

      var _component_f7_navbar = _resolveComponent("f7-navbar");

      var _component_f7_col = _resolveComponent("f7-col");

      var _component_f7_row = _resolveComponent("f7-row");

      var _component_BaseImg = _resolveComponent("BaseImg");

      var _component_f7_swiper_slide = _resolveComponent("f7-swiper-slide");

      var _component_f7_swiper = _resolveComponent("f7-swiper");

      var _component_f7_skeleton_block = _resolveComponent("f7-skeleton-block");

      var _component_ProductBox = _resolveComponent("ProductBox");

      var _component_BaseSpacer = _resolveComponent("BaseSpacer");

      var _component_AppShowcasePopup = _resolveComponent("AppShowcasePopup");

      var _component_BarcodePopup = _resolveComponent("BarcodePopup");

      var _component_f7_page = _resolveComponent("f7-page");

      return _openBlock(), _createBlock(_component_f7_page, {
        name: "home",
        class: "p-index sty-page-bottom-veg-deco2",
        "page-content": false
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_f7_navbar, {
            noShadow: "",
            noHairline: "",
            class: "navbar-index"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_f7_nav_left, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_f7_link, {
                    class: "",
                    "panel-open": "left"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_1];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }), _createVNode(_component_f7_nav_title, null, {
                default: _withCtx(function () {
                  return [_hoisted_2];
                }),
                _: 1
              }), _createVNode(_component_f7_nav_right, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_MailIndicator)];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode("div", _hoisted_3, [_createVNode("div", _hoisted_4, [_createVNode("div", _hoisted_5, [_createVNode(_component_f7_row, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_f7_col, {
                width: "55",
                class: "col-left"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_f7_link, {
                    class: "pill-2pend-btn",
                    onClick: _cache[1] || (_cache[1] = function ($event) {
                      openCodePopup();
                    })
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_6, _hoisted_7];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }), _createVNode(_component_f7_col, {
                width: "45",
                class: "col-right",
                onClick: _cache[2] || (_cache[2] = function ($event) {
                  return getPoint('queryPoints');
                })
              }, {
                default: _withCtx(function () {
                  return [_createVNode("div", _hoisted_8, [_hoisted_9, hasFetchedPoints.value ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(_unref(store).state.auth.total_point) + " 點 ", 1)) : _createCommentVNode("", true), !hasFetchedPoints.value ? (_openBlock(), _createBlock("div", _hoisted_11, " 查詢點數 ")) : _createCommentVNode("", true)])];
                }),
                _: 1
              })];
            }),
            _: 1
          })])]), _createVNode(_component_f7_skeleton_block, {
            style: {
              "--skeleton-color": "transparent"
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_f7_swiper, {
                pagination: "",
                id: "swiper-index",
                spaceBetween: 0,
                slidesPerView: 1,
                autoplay: {
                  delay: 8000
                }
              }, {
                default: _withCtx(function () {
                  return [(_openBlock(true), _createBlock(_Fragment, null, _renderList(_unref(pageData).banner, function (banner) {
                    return _openBlock(), _createBlock(_component_f7_swiper_slide, {
                      key: banner.banner_id
                    }, {
                      default: _withCtx(function () {
                        return [_createVNode(_component_f7_link, {
                          "prevent-router": true,
                          external: "",
                          href: "javascript:;",
                          onClick: function onClick($event) {
                            return _ctx.$window._open_browser(banner.url);
                          }
                        }, {
                          default: _withCtx(function () {
                            return [_createVNode(_component_BaseImg, {
                              src: banner.pic_src,
                              absFill: ""
                            }, null, 8, ["src"])];
                          }),
                          _: 2
                        }, 1032, ["onClick"])];
                      }),
                      _: 2
                    }, 1024);
                  }), 128))];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode("div", _hoisted_12, [_createVNode("div", _hoisted_13, [_createVNode(_component_f7_row, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_f7_col, {
                width: "25"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_f7_link, {
                    href: "/preorder_product_list",
                    class: ["btn-feature sty-green", {
                      active: btnActiveName.value === 'fabrics'
                    }],
                    onClick: _cache[3] || (_cache[3] = function ($event) {
                      return btnActiveName.value = 'fabrics';
                    })
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_14, _hoisted_15];
                    }),
                    _: 1
                  }, 8, ["class"])];
                }),
                _: 1
              }), _createVNode(_component_f7_col, {
                width: "25"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_f7_link, {
                    href: "/proposal_list",
                    class: ["btn-feature sty-red", {
                      active: btnActiveName.value === 'news'
                    }],
                    onClick: _cache[4] || (_cache[4] = function ($event) {
                      return btnActiveName.value = 'news';
                    })
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_16, _hoisted_17];
                    }),
                    _: 1
                  }, 8, ["class"])];
                }),
                _: 1
              }), _createVNode(_component_f7_col, {
                width: "25"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_f7_link, {
                    href: "/order_records",
                    class: ["btn-feature sty-purple", {
                      active: btnActiveName.value === 'chat'
                    }],
                    onClick: _cache[5] || (_cache[5] = function ($event) {
                      return btnActiveName.value = 'chat';
                    })
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_18, _hoisted_19];
                    }),
                    _: 1
                  }, 8, ["class"])];
                }),
                _: 1
              }), _createVNode(_component_f7_col, {
                width: "25"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_f7_link, {
                    href: "/play_ground",
                    class: ["btn-feature sty-sea", {
                      active: btnActiveName.value === 'labdip'
                    }],
                    onClick: _cache[6] || (_cache[6] = function ($event) {
                      return btnActiveName.value = 'labdip';
                    })
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_20, _hoisted_21];
                    }),
                    _: 1
                  }, 8, ["class"])];
                }),
                _: 1
              }), _createVNode(_component_f7_col, {
                width: "25"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_f7_link, {
                    href: "/discount_info",
                    class: ["btn-feature sty-orange", {
                      active: btnActiveName.value === 'pen'
                    }],
                    onClick: _cache[7] || (_cache[7] = function ($event) {
                      return btnActiveName.value = 'pen';
                    })
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_22, _hoisted_23];
                    }),
                    _: 1
                  }, 8, ["class"])];
                }),
                _: 1
              }), _createVNode(_component_f7_col, {
                width: "25"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_f7_link, {
                    class: ["btn-feature sty-cryan", {
                      active: btnActiveName.value === 'order'
                    }],
                    onClick: _cache[8] || (_cache[8] = function ($event) {
                      btnActiveName.value = 'order';

                      _unref(goMobileStore)();
                    })
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_24, _hoisted_25];
                    }),
                    _: 1
                  }, 8, ["class"])];
                }),
                _: 1
              }), _createVNode(_component_f7_col, {
                width: "25"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_f7_link, {
                    href: "/news_list",
                    class: ["btn-feature sty-blue", {
                      active: btnActiveName.value === 'order'
                    }],
                    onClick: _cache[9] || (_cache[9] = function ($event) {
                      return btnActiveName.value = 'order';
                    })
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_26, _hoisted_27];
                    }),
                    _: 1
                  }, 8, ["class"])];
                }),
                _: 1
              }), _createVNode(_component_f7_col, {
                width: "25"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_f7_link, {
                    href: "/shopping_records",
                    class: ["btn-feature sty-yellow", {
                      active: btnActiveName.value === 'order'
                    }],
                    onClick: _cache[10] || (_cache[10] = function ($event) {
                      return btnActiveName.value = 'order', getPoint('consumptionRecord');
                    })
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_28, _hoisted_29];
                    }),
                    _: 1
                  }, 8, ["class"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })]), _unref(store).state.home.home_product_list && _unref(store).state.home.home_product_list.length !== 0 ? (_openBlock(), _createBlock(_Fragment, {
            key: 0
          }, [_createVNode("div", _hoisted_30, [_hoisted_31, _createVNode("div", _hoisted_32, [_createVNode("div", {
            class: "more-btn",
            onClick: _cache[11] || (_cache[11] = function ($event) {
              return _ctx.$f7.view.main.router.navigate('/preorder_product_list');
            })
          }, " 更多 ")])]), _createVNode("div", _hoisted_33, [_createVNode(_component_f7_row, null, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createBlock(_Fragment, null, _renderList(_unref(store).state.home.home_product_list, function (product) {
                return _openBlock(), _createBlock(_component_f7_col, {
                  width: "50",
                  key: "".concat(product.id, "_").concat(product.spec_id)
                }, {
                  default: _withCtx(function () {
                    return [_createVNode(_component_ProductBox, {
                      cartType: __unimport_mukiConst.cartType.ONLINE_PREORDER,
                      id: product.id,
                      specId: product.spec_id,
                      countDown: product.countdown,
                      isCollect: product.is_collect,
                      "onUpdate:isCollect": function onUpdateIsCollect($event) {
                        return product.is_collect = $event;
                      },
                      stock: product.stock,
                      name: product.name,
                      picSrc: product.pic_src,
                      oriPrice: product.ori_price,
                      product_price_spec_data: product.product_price_spec_data,
                      onClick: function onClick($event) {
                        _ctx.$f7.view.main.router.navigate("/product_detailed/".concat(product.id, "/").concat(__unimport_mukiConst.cartType.ONLINE_PREORDER), {
                          props: {
                            onBackPage: function onBackPage(data) {
                              // 設定返回時及時更新is_collect狀態 
                              product.is_collect = data.is_collect;
                            }
                          }
                        });
                      }
                    }, null, 8, ["cartType", "id", "specId", "countDown", "isCollect", "onUpdate:isCollect", "stock", "name", "picSrc", "oriPrice", "product_price_spec_data", "onClick"])];
                  }),
                  _: 2
                }, 1024);
              }), 128))];
            }),
            _: 1
          })])], 64)) : _createCommentVNode("", true), _unref(pageData).ad_block && _unref(pageData).ad_block.length ? (_openBlock(), _createBlock("div", _hoisted_34, [(_openBlock(true), _createBlock(_Fragment, null, _renderList(_unref(pageData).ad_block, function (block, idx) {
            return _openBlock(), _createBlock(_Fragment, {
              key: idx
            }, [block.pics && block.pics.length === 1 ? (_openBlock(), _createBlock(_Fragment, {
              key: 0
            }, [_createVNode("div", _hoisted_35, [_createVNode("div", _hoisted_36, [_createVNode("div", _hoisted_37, [_hoisted_38, _createTextVNode(" " + _toDisplayString(block.topic), 1)])])]), _createVNode("div", _hoisted_39, [_createVNode(_component_f7_row, null, {
              default: _withCtx(function () {
                return [(_openBlock(true), _createBlock(_Fragment, null, _renderList(block.pics, function (item) {
                  return _openBlock(), _createBlock(_component_f7_col, {
                    key: item.id
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_f7_link, {
                        class: "media-block-item ratio-768by290 external",
                        onClick: function onClick($event) {
                          return _ctx.$window._open_browser(item.url);
                        }
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_BaseImg, {
                            src: item.pic_src,
                            absFill: ""
                          }, null, 8, ["src"])];
                        }),
                        _: 2
                      }, 1032, ["onClick"])];
                    }),
                    _: 2
                  }, 1024);
                }), 128))];
              }),
              _: 2
            }, 1024)])], 64)) : _createCommentVNode("", true), block.pics && block.pics.length === 2 ? (_openBlock(), _createBlock(_Fragment, {
              key: 1
            }, [_createVNode("div", _hoisted_40, [_createVNode("div", _hoisted_41, [_createVNode("div", _hoisted_42, [_hoisted_43, _createTextVNode(" " + _toDisplayString(block.topic), 1)])])]), _createVNode("div", _hoisted_44, [_createVNode(_component_f7_row, null, {
              default: _withCtx(function () {
                return [(_openBlock(true), _createBlock(_Fragment, null, _renderList(block.pics, function (item) {
                  return _openBlock(), _createBlock(_component_f7_col, {
                    width: "50",
                    key: item.id
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_f7_link, {
                        class: "media-block-item ratio-655by470 external",
                        onClick: function onClick($event) {
                          return _ctx.$window._open_browser(item.url);
                        }
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_BaseImg, {
                            src: item.pic_src,
                            absFill: ""
                          }, null, 8, ["src"])];
                        }),
                        _: 2
                      }, 1032, ["onClick"])];
                    }),
                    _: 2
                  }, 1024);
                }), 128))];
              }),
              _: 2
            }, 1024)])], 64)) : _createCommentVNode("", true), block.pics && block.pics.length === 3 ? (_openBlock(), _createBlock(_Fragment, {
              key: 2
            }, [_createVNode("div", _hoisted_45, [_createVNode("div", _hoisted_46, [_createVNode("div", _hoisted_47, [_hoisted_48, _createTextVNode(" " + _toDisplayString(block.topic), 1)])])]), _createVNode("div", _hoisted_49, [_createVNode(_component_f7_row, {
              class: "align-items-center"
            }, {
              default: _withCtx(function () {
                return [(_openBlock(true), _createBlock(_Fragment, null, _renderList(block.pics.slice(0, 1), function (item) {
                  return _openBlock(), _createBlock(_component_f7_col, {
                    key: item.id,
                    width: "50"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_f7_link, {
                        class: "media-block-item external",
                        onClick: function onClick($event) {
                          return _ctx.$window._open_browser(item.url);
                        }
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_BaseImg, {
                            src: item.pic_src
                          }, null, 8, ["src"])];
                        }),
                        _: 2
                      }, 1032, ["onClick"])];
                    }),
                    _: 2
                  }, 1024);
                }), 128)), _createVNode(_component_f7_col, {
                  width: "50"
                }, {
                  default: _withCtx(function () {
                    return [(_openBlock(true), _createBlock(_Fragment, null, _renderList(block.pics.slice(1, block.pics.length), function (item) {
                      return _openBlock(), _createBlock(_component_f7_link, {
                        key: item.id,
                        class: "media-block-item side-item external",
                        onClick: function onClick($event) {
                          return _ctx.$window._open_browser(item.url);
                        }
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_BaseImg, {
                            src: item.pic_src
                          }, null, 8, ["src"])];
                        }),
                        _: 2
                      }, 1032, ["onClick"]);
                    }), 128))];
                  }),
                  _: 2
                }, 1024)];
              }),
              _: 2
            }, 1024)])], 64)) : _createCommentVNode("", true)], 64);
          }), 128))])) : _createCommentVNode("", true), _unref(pageData).event_block && _unref(pageData).event_block.pics && _unref(pageData).event_block.pics.length ? (_openBlock(), _createBlock(_Fragment, {
            key: 2
          }, [_hoisted_50, _createVNode("div", _hoisted_51, [_createVNode(_component_f7_row, null, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createBlock(_Fragment, null, _renderList(_unref(pageData).event_block.pics, function (item, idx) {
                return _openBlock(), _createBlock(_component_f7_col, {
                  key: item.id,
                  width: idx == 0 ? '100' : '50'
                }, {
                  default: _withCtx(function () {
                    return [_createVNode("div", {
                      class: ["media-block-item", idx == 0 ? 'ratio-auto' : 'ratio-1by1']
                    }, [_createVNode(_component_BaseImg, {
                      src: item.pics,
                      absFill: ""
                    }, null, 8, ["src"])], 2)];
                  }),
                  _: 2
                }, 1032, ["width"]);
              }), 128))];
            }),
            _: 1
          })])], 64)) : _createCommentVNode("", true)]), _createVNode(_component_BaseSpacer, {
            h: "10px"
          })]), _createVNode(_component_AppShowcasePopup), _createVNode(_component_BarcodePopup, {
            ref: childComponentRef
          }, null, 512)];
        }),
        _: 1
      });
    };
  }
};